import { ssrApi } from 'api/ssr';
import { ReviewSlot, Props } from 'components/template/review-casino-slot';
import { ParsedUrlQuery } from 'querystring';
import {
  isValidEntity,
  notFoundResult,
  unwrapEntity,
} from 'utils/ssr-not-found';

export default function Viewer({ casino }: Props) {
  return <ReviewSlot casino={casino} />;
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const { id } = query;

  const casino = await ssrApi.casinos.getById(id?.toString());

  if (!isValidEntity(casino)) {
    return notFoundResult();
  }

  return {
    props: { casino: unwrapEntity(casino) },
  };
}
